import React, { Component } from 'react';

class Hero extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="hero">
        <div className="container">
          <h1>Your complete guide to<br />skin health.</h1>
          <p>Find information from experts on skin conditions, including symptoms, causes, diagnosis, and treatment options.</p>
        </div>
      </div>
    );
  }
}

Hero.defaultProps = {};
Hero.propTypes = {};

export default Hero;
